// import styled from 'styled-components';
import styled from "@emotion/styled";

type ActivityTableTypes = {
	active?: boolean;
};

export const ActivityTable = styled.div<ActivityTableTypes>`
  width: 100%;

  table {
    width: 100%;

    td {
      padding: 12px 12px 12px 0;
      border-bottom: 1px solid ${(props: any) => props.theme.colors.b.lg};
      font-size: ${(props: any) => props.theme.fontSizes.md};
      color: ${(props: any) => props.theme.colors.b.g};
      line-height: 1.4;
      word-break: keep-all;
      white-space: pre-wrap;

      &:first-child {
        /* white-space: nowrap; */
        word-break: keep-all;
        /* min-width: 200px; */
      }

      div {
        display: inline;
      }
    }

    tr:first-child {
      td {
        font-size: ${(props: any) => props.theme.fontSizes.lg};
        color: ${(props: any) => props.theme.colors.b.dgr};
        font-weight: bold;
        border-bottom: 2px solid ${(props: any) => props.theme.colors.b.dgr};
        white-space: nowrap;
      }
    }
  }
`;

export const VideoBanner = styled.div`
  .slick-slider {
    .slick-prev {
      left: 20px;
      transform: translate(0, -30px);
    }
    .slick-next {
      right: 20px;
      transform: translate(0, -30px);
    }
  }
`;

export const ShesViewBannerSection = styled.div`
  /* height: 360px; */
  /* overflow: hidden; */

	.slick-slider {
		.slick-prev {
			left: 50%;
			margin-left: 490px;
			top: -60px;
		}
		.slick-next {
			left: 50%;
			margin-left: 560px;
			top: -60px;
		}
		.slick-slide {
			opacity: 0.25;
			&.slick-active {
				opacity: 1;
			}
		}
	}
`;

export const ActivityFullContent = styled.div`
  .wp-block-image {
    margin-bottom: 20px;
    width: 100%;
    img {
      width: 100%;
    }
  }

  .wp-block-columns {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;

    * {
      flex-basis: auto;
      flex-grow: 0;
    }

    > .wp-block-column {
      
      &:first-child {
        width: 30%;
      }

      &:nth-child(2) {
        width: 75%;
      }      

      p {
        font-size: ${(props: any) => props.theme.fontSizes['lg']};
        line-height: 1.6;
      }

      p > strong {
        font-size: ${(props: any) => props.theme.fontSizes['2xl']};
        font-weight: bold;
      }

      .wp-block-columns {
        padding: 0 0 6px 0;

        > .wp-block-column:nth-child(1) {
          flex-basis: 20%!important;
        }
        > .wp-block-column:nth-child(2) {
          flex-basis: 80%!important;
        }
      }
    }
  }

`
